import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';

@Component({
    selector: 'customer-contact-person-delete-confirm-dialog',
    templateUrl: './customer-contact-person-delete-confirm.dialog.component.html',
    styleUrls: ['./customer-contact-person-delete-confirm.dialog.component.scss']
})
export class CustomerContactPersonDeleteConfirmDialogComponent {

    person: CustomerContactPerson;

    constructor(public dialog: MatDialogRef<CustomerContactPersonDeleteConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.person = data.person;
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerContactPersonDeleteConfirmDialogComponent/customer-contact-person-delete-confirm.dialog.component.ts